import { POWER_ORIGINALS_LABEL } from "@/domain/casino/ai-images/card-label"

export const casinoPageTexts = {
  title: "Powerbet Casino",
  description:
    "Descubre los mejores juegos de casino en línea en Powerbet. Vive la emoción de ganar con juegos crash, tragamonedas, y mucho más. ¡Juega ahora!"
} as const

export const gameCardTexts = {
  noImage: "No image",
  play: "Play",
  addFavorite: "Agregar a favoritos",
  removeFavorite: "Quitar de favoritos",
  powerOriginals: POWER_ORIGINALS_LABEL
} as const

export const gamePreviewTexts = {
  openGame: "Ver juego"
} as const

export const recentWinsTexts = {
  title: "Victorias Recientes",
  player: "Usuario",
  stake: "Apuesta",
  multiplier: "Multiplicador",
  payout: "Pago"
} as const

export const playTexts = {
  back: "Volver",
  play: "Jugar",
  demo: "Demo",
  by: "by",
  loading: "Cargando el juego",
  gameFrameTitle: "Hub88 Game",
  fullscreen: "Pantalla completa",
  exitFullscreen: "Salir de pantalla completa",
  shield: "Escudo",
  relatedGames: "Juegos Relacionados",
  moreGames: "Ver Mas Juegos",
  toast: {
    title: "Error",
    loginRequired: "Inicia sesión para jugar"
  },
  errors: {
    unavailable: {
      text1: "Este juego no está disponible en estos momentos",
      text2: "Prueba uno de nuestros juegos recomendados"
    },
    currency: {
      text1: "Este juego no está disponible en tu moneda",
      text2: "Por favor, selecciona otro juego"
    }
  }
} as const

export type PlayErrorMessage = {
  text1: string
  text2: string
}

export const categoryGamesPreviewTexts = {
  button: "VER TODO",
  seeAllAria: "Ver todos los juegos",
  empty: "No hay juegos disponibles por ahora"
} as const

export const searchTexts = {
  title: "Buscar",
  placeholder: "Buscar",
  games: "Juegos",
  gamesNone: "RAYO no encontró esto :(",
  popularPrompt: "Prueba nuestros juegos populares:",
  recommendedPrompt: "Juegos recomendados",
  gamesLoading: "Buscando juegos",
  gamesError: "No se pudieron cargar los juegos",
  gamesResults: "Resultados de búsqueda: {count}",
  filters: "Filtros",
  dismiss: "Cerrar búsqueda"
} as const

export function formatSearchResults(count: number) {
  return searchTexts.gamesResults.replace("{count}", String(count))
}

export const lobbyLoaderTexts = {
  ariaLabel: "Cargando el lobby"
} as const

export const lobbyTexts = {
  ariaLabel: "Lobby de casino",
  searchPlaceholder: "Search",
  chipsAria: "Categorías de casino",
  chips: {
    originals: "Originals",
    slots: "Slots",
    blackjack: "Blackjack",
    live: "Juegos en Vivo",
    popular: "Popular"
  },
  filters: {
    providers: "Providers",
    sort: "Ordenar",
    providerAll: "Todos",
    providerSearch: "Buscar",
    providerEmpty: "No hay proveedores",
    sortDefault: "Predeterminado",
    sortOptions: {
      newest: "Más nuevo",
      oldest: "Más antiguo",
      popularity: "Popularidad",
      currentPlayers: "Jugadores actuales"
    }
  },
  providerLogos: {
    felt: "Felt",
    habanero: "Habanero",
    gameArt: "Game Art",
    gamingCorp: "Gaming Corp",
    pragmatic: "Pragmatic Play",
    evolution: "Evolution",
    playtech: "Playtech",
    netent: "NetEnt"
  },
  rails: {
    originals: "Powerbet Originals",
    winningNow: "Ganando ahora",
    slots: "Slots",
    blackjack: "Blackjack",
    live: "Juegos en Vivo",
    providers: "Proveedores"
  },
  filtered: {
    displaying: "Displaying {shown} of {total} Games.",
    loadMore: "LOAD MORE"
  }
} as const

export function formatFilteredDisplaying(shown: number, total: number) {
  return lobbyTexts.filtered.displaying
    .replace("{shown}", String(shown))
    .replace("{total}", String(total))
}
